<template>
  <tm-diag-point
    v-if="gridEstablished"
    :point="$data.timePoint"
    :data-label="label"
    :data-xy="xy"
  />
</template>

<script>
import gridMixin from '../grid.mixin';
import { TimePoint } from '../../api/grid';
import tmDiagPoint from './tmDiagPoint.vue';
import fg from '#/libs/FrameGrid';

export default {
  name: 'tm-diag-mouse-point',
  components: { tmDiagPoint },
  mixins: [gridMixin],

  data() {
    return {
      timePoint: new TimePoint(),
    };
  },

  computed: {
    label() {
      return fg.trunc(this.$data.timePoint.time);
    },
    xy() {
      return `${this.$data.timePoint.x}x${this.$data.timePoint.y}`;
    },
  },

  beforeDestroy() {
    window.removeEventListener('mousemove', this.$_onMousemove);
  },

  mounted() {
    window.addEventListener('mousemove', this.$_onMousemove);
  },

  methods: {
    $_onMousemove(e) {
      if (this.gridEstablished) {
        this.$_mouse2point(e, this.$data.timePoint);
      }
    },
  },
};
</script>
